import { useState, useContext, useEffect } from 'react';
import { db, timestamp } from "../../firebase/config";
import { SavedIcon } from "../../StateManagment/SavedIcon";
import deleteIcon from '../../images/icons/delete-icon.png'
import otherIcon from '../../images/icons/other-icon.png'
import Tooltip from '../common/Tooltip';
import { client } from "../../hooks/Client";
import uuid from 'react-uuid';
import { useFirestoreGeneralOrderBy } from '../../firebase/useFirestore';
import useSettings from '../../hooks/Settings';
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import CheckBoxOutlineBlankOutlinedIcon from '@mui/icons-material/CheckBoxOutlineBlankOutlined';
import MatrixOne from './questionTypes/MatrixOne';
import DragIndicatorOutlinedIcon from '@mui/icons-material/DragIndicatorOutlined';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import VisibilityRule from './VisibilityRule';
import softDeleteDoc from '../../helpers/softDeleteDoc';
import scaleStartLabel from '../../helpers/questionnaire/scaleStartLabel';

/**
 * @param {object} props
 * @param {object} props.field - Het QuestionnaireFields-doc dat bewerkt wordt
 * @param {number} props.index - Positie van de vraag in de vragenlijst (weergave)
 * @param {string} [props.type] - Ongebruikt; blijft voor bestaande aanroepers
 * @param {Array<object>} [props.allFields] - Alle velden van de vragenlijst,
 *   nodig om te bepalen welke eerdere vragen als trigger kunnen dienen
 */
const QuestionnaireField = ({field, index, type, allFields}) => {
  // Context
  const [saved, setSaved] = useContext(SavedIcon)

  // States
  const [multiple, setMultiple] = useState('')

  // DnD local state for options (mirrors Firestore)
  const [optionsDrag, setOptionsDrag] = useState([]);

  // Hooks
  const {
    PrimaryColor: primaryColor,
    SecundairyColor: secundairyColor,
    TertairyColor: tertiaryColor,
  } = useSettings();
  const colors = [primaryColor, secundairyColor, tertiaryColor];

  // Firestore
  const multipleOptions = useFirestoreGeneralOrderBy('MultipleQuestionOptions', 'Field', field.ID, 'Position', 'asc')

  // Keep local drag array in sync with Firestore
  useEffect(() => {
    setOptionsDrag(multipleOptions || []);
  }, [multipleOptions]);

  // Helper function to get a random color
  const getRandomColor = () => {
    const randomIndex = Math.floor(Math.random() * colors.length);
    return colors[randomIndex];
  }

  // Explainer Handler
  const explainerHandler = (e) => {
    const value = e.target.value 
    const docid = e.target.dataset.docid 

    db.collection('QuestionnaireFields')
      .doc(docid)
      .update({ Explainer: value })
      .then(() => setSaved('flex'))
  }

  // Type Handler
  const typeHandler = (e) => {
    const type = e.target.options[e.target.selectedIndex].value
    const docid = e.target.dataset.docid

    console.log(type)
    console.log(docid)

    db.collection('QuestionnaireFields')
      .doc(docid)
      .update({ Type: type })
      .then(() => setSaved('flex'))
  }

  // Reach Start Handler
  const reachStartHandler = (e) => {
    const reachStart = e.target.options[e.target.selectedIndex].value 
    const docid = e.target.dataset.docid

    db.collection('QuestionnaireFields')
      .doc(docid)
      .update({ ReachStart: Number(reachStart) })
      .then(() => setSaved('flex'))
  }

  // Reach Start Label Handler
  const reachStartLabelHandler = (e) => {
    const reachStartLabel = e.target.value 
    const docid = e.target.dataset.docid

    db.collection('QuestionnaireFields')
      .doc(docid)
      .update({ ReachStartLable: reachStartLabel })
      .then(() => setSaved('flex'))
  }

  // Reach End Handler
  const reachEndHandler = (e) => {
    const reachEnd = e.target.options[e.target.selectedIndex].value 
    const docid = e.target.dataset.docid

    db.collection('QuestionnaireFields')
      .doc(docid)
      .update({ ReachEnd: Number(reachEnd) })
      .then(() => setSaved('flex'))
  }

  // Reach End Label Handler
  const reachEndLabelHandler = (e) => {
    const reachEndLabel = e.target.value 
    const docid = e.target.dataset.docid

    db.collection('QuestionnaireFields')
      .doc(docid)
      .update({ ReachEndLabel: reachEndLabel })
      .then(() => setSaved('flex'))
  }

  // Multiple: add empty option
  const saveMultiple = (e) => {
    const id = e.currentTarget.dataset.id

    db.collection('MultipleQuestionOptions')
      .doc()
      .set({
        Option: multiple, // empty string by default; user can type
        Question: '',
        Field: id,
        Compagny: client,
        CompagnyID: client,
        Timestamp: timestamp,
        Position: (multipleOptions?.length || 0) + 1,
        ID: uuid(),
        Color: getRandomColor()
      })
      .then(() => setSaved('flex'))
  }

  // Add "other" option
  const addOtherHandler = (e) => {
    const id = e.currentTarget.dataset.id

    db.collection('MultipleQuestionOptions')
      .doc()
      .set({
        Option: 'other',
        Question: field.Question,
        Field: id,
        Compagny: client,
        CompagnyID: client,
        Timestamp: timestamp,
        Position: (multipleOptions?.length || 0) + 1,
        ID: uuid(),
        Color: getRandomColor()
      })
      .then(() => setSaved('flex'))
  }

  // Edit Multiple Handler
  const editMultipleHandler = (e) => {
    const value = e.target.value
    const docid = e.target.dataset.docid

    db.collection('MultipleQuestionOptions')
      .doc(docid)
      .update({ Option: value })
      .then(() => setSaved('flex'))
  }

  // Delete Multiple Handler
  const deleteMulitple = (e) => {
    const docid = e.currentTarget.dataset.docid

    softDeleteDoc({ collection: 'MultipleQuestionOptions', docid })
      .then(() => setSaved('flex'))
  }

  // DRAG & DROP for MultipleQuestionOptions (same logic as Activities)
  const handleOptionsDragEnd = (result) => {
    if (!result.destination) return;

    const items = Array.from(optionsDrag);
    const [moved] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, moved);

    // Update local state immediately
    setOptionsDrag(items);

    // Persist new order to Firestore
    items.forEach((opt, idx) => {
      db.collection('MultipleQuestionOptions')
        .doc(opt.docid) // docid attached by your hook
        .update({ Position: idx + 1 });
    });

    setSaved('flex');
  };

  // Verplichte vraag aan/uit. Een echte boolean, net als MatrixBipolar — de
  // open vragenlijst leest hem met `=== true`, dus de tekst 'false' (die in
  // deze database ook voorkomt voor oudere vlaggen) zou daar als 'ja' gelden.
  // AI-CONTEXT: See docs/pitfalls.md#ui-togglebutton-string-only-branches
  const requiredHandler = (e) => {
    db.collection('QuestionnaireFields')
      .doc(field.docid)
      .update({ Required: e.target.checked })
      .then(() => {
        setSaved('flex')
      })
  }

  // Shared renderer for both multiple-one & multiple-multiple
  const renderMultipleOptions = () => (
    <>
      <span className="qb-field-label">Antwoordopties</span>
      <div className='questionnaire-suggestion-container'>
        <Tooltip content='Antwoord toevoegen' top='-60px' width={'30px'}>
          <AddCircleOutlineOutlinedIcon className='table-delete-icon' data-id={field.ID} onClick={saveMultiple}/> 
        </Tooltip>  
        <Tooltip content="Anders, namelijk.. toevoegen" top='-80px' width={'30px'}>
          <img src={otherIcon} alt="" data-id={field.ID} onClick={addOtherHandler}/>
        </Tooltip>
      </div>

      {/* OPTIONS with react-beautiful-dnd */}
      <DragDropContext onDragEnd={handleOptionsDragEnd}>
        <Droppable droppableId={`options-${field.ID}`} direction="vertical">
          {(provided) => (
            <div
              id='options-container'
              ref={provided.innerRef}
              {...provided.droppableProps}
            >
              {optionsDrag && optionsDrag.map((item, idx) => (
                <Draggable key={item.ID} draggableId={item.ID} index={idx}>
                  {(provided) => (
                    <div
                      className='multiple-option-row'
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                    >
                      {/* Drag handle */}
                      <span className='drag-handle' {...provided.dragHandleProps}>
                        <DragIndicatorOutlinedIcon />
                      </span>

                      {item.Option === 'other' ? (
                        <>
                          <CheckBoxOutlineBlankOutlinedIcon />
                          <p id='multiple-question-other'>Anders, namelijk...</p>
                          <img
                            className='muitple-delete-icon'
                            data-docid={item.docid}
                            data-item={item.Option}
                            onClick={deleteMulitple}
                            src={deleteIcon}
                            alt=""
                            data-index={idx}
                          />
                        </>
                      ) : (
                        <>
                          <CheckBoxOutlineBlankOutlinedIcon />
                          <input
                            className='question-checkbox-input'
                            placeholder='Schrijf hier de antwoordoptie'
                            data-docid={item.docid}
                            defaultValue={item.Option}
                            onChange={editMultipleHandler}
                          />
                          <img
                            className='muitple-delete-icon'
                            data-docid={item.docid}
                            data-item={item.Option}
                            onClick={deleteMulitple}
                            src={deleteIcon}
                            alt=""
                            data-index={idx}
                          />
                        </>
                      )}
                    </div>
                  )}
                </Draggable>
              ))}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    </>
  );

  return(
    <div className='question-type-display-container'>
      <div className='questionnaire-field-top-level-container'>
        <span className="qb-field-label">Vraagtype</span>
        <select name="" id="" onChange={typeHandler} defaultValue={field.Type} data-docid={field.docid} data-index={index} >
          <option value="paragraph">Open vraag</option>
          <option value="scale">Schaal vraag</option>
          <option value="number">Nummerieke vraag</option>
          <option value="multiple-multiple">Meerkeuze vraag (meerdere antwoorden)</option>
          <option value="multiple-one">Meerkeuze vraag (één antwoord)</option>
          <option value="matrix-one">Matrix vraag(één antwoord)</option>
        </select>
      </div>

      <div data-index={index}>
        <span className="qb-field-label">Toelichting</span>
        <textarea className='question-subtitle-textarea' data-index={index} placeholder='Geef een toelichting (optioneel)'  cols="10" rows="5" data-docid={field.docid} defaultValue={field.Explainer} onChange={explainerHandler}></textarea>
      </div>

      <VisibilityRule field={field} allFields={allFields} />

      <label className='qb-required-toggle'>
        <input type='checkbox' checked={field.Required === true} onChange={requiredHandler} />
        <span>Verplichte vraag</span>
      </label>
      <p className='qb-required-explainer'>
        De respondent kan pas verder als deze vraag beantwoord is. Bij een matrixvraag moet elke rij ingevuld zijn.
      </p>

      {/* Paragraph */}
      <div className='questionnaire-field-type-paragraph-container' style={{display: field.Type === 'paragraph' ? 'block' : 'none'}}>
        <p className='questionnaire-field-type-text' data-index={index}>Antwoord</p>
      </div>

      {/* Scale */}
      <div className='questionnaire-field-scale-container' style={{display: field.Type === 'scale' ? 'block' : 'none'}}>
        <span className="qb-field-label">Schaal</span>
        <div className='edit-scale-container'>
          <div className='select-scale-container' data-index={index}>
            <select name="" id="" onChange={reachStartHandler} defaultValue={field.ReachStart} data-docid={field.docid}  data-index={index}>
              <option value="">-- Selecteer onderwaarde ---</option>
              <option value={0}>0</option>
              <option value={1}>1</option>
            </select>
            <input type="text" placeholder='Voeg label toe (optioneel)' defaultValue={scaleStartLabel(field)} data-docid={field.docid} onChange={reachStartLabelHandler} data-index={index}/>
          </div>
          <p id='scale-reach-symbol' data-index={index}>t/m</p>
          <div className='select-scale-container' data-index={index}>
            <select name="" id="" onChange={reachEndHandler} data-docid={field.docid} defaultValue={field.ReachEnd} data-index={index}>
              <option value="">-- Selecteer bovenwaarde --</option>
              <option value={2}>2</option>
              <option value={3}>3</option>
              <option value={4}>4</option>
              <option value={5}>5</option>
              <option value={6}>6</option>
              <option value={7}>7</option>
              <option value={8}>8</option>
              <option value={9}>9</option>
              <option value={10}>10</option>
            </select>
            <input type="text" placeholder='Voeg label toe (optioneel)' data-docid={field.docid} defaultValue={field.ReachEndLabel} onChange={reachEndLabelHandler} data-index={index}/>
          </div>
        </div>
      </div>

      {/* Number */}
      <div className='questionnaire-field-type-paragraph-container' style={{display: field.Type === 'number' ? 'block' : 'none'}}>
        <p className='questionnaire-field-type-text' data-index={index}>Antwoord</p>
      </div>

      {/* Multiple-multiple (DnD) */}
      <div style={{display: field.Type === 'multiple-multiple' ? 'block' : 'none'}}>
        {renderMultipleOptions()}
      </div>

      {/* Multiple-one (DnD) */}
      <div style={{display: field.Type === 'multiple-one' ? 'block' : 'none'}}>
        {renderMultipleOptions()}
      </div>

      {/* Matrix-one */}
      <MatrixOne field={field} index={index}/>
    </div>
  )
}

export default QuestionnaireField
